import { render } from "./SecretaryView.vue?vue&type=template&id=20bc86e7"
import script from "./SecretaryView.vue?vue&type=script&lang=js"
export * from "./SecretaryView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__